import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import parse from "html-react-parser";
import React from "react";

interface OwnProps {
    message: string;
}

const FreeFreightMessage = ({ message }: OwnProps) => {
    if (!message) {
        return null;
    }

    return <div>{parse(message, parserOptions)}</div>;
};

export default FreeFreightMessage;
